import React from 'react';
import PropTypes from 'prop-types';
import {
  ResourceOverviewToolbarContext,
  useResourceOverviewToolbarContextValue
} from '~/modules/resource-management/ResourcingOverview/hooks';

const ResourceOverviewToolbarContextProvider = ({
  children,
  chartSettings
}) => {
  const contextValues = useResourceOverviewToolbarContextValue({
    chartSettings
  });

  return (
    <ResourceOverviewToolbarContext.Provider value={contextValues}>
      {children}
    </ResourceOverviewToolbarContext.Provider>
  );
};

ResourceOverviewToolbarContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  chartSettings: PropTypes.object
};

export default ResourceOverviewToolbarContextProvider;
